/*
CUSTOMIZATIONS:
- aggiunta proprietà "device" che permette all'utente selezionare da menu a tendina, il dispositivo sulla quale vuole mostrare l'immagine.
- l'opzione di selezionamento della dimensione dell'immagine "s,m,l" ora viene mostrata solo per le immagini che non sono in full-width, al contrario viene mostrato invece il check di tenere le dimensioni naturali dell'immagine
*/

import { defineMessages } from 'react-intl';

const messages = defineMessages({
  Source: {
    id: 'Source',
    defaultMessage: 'Source',
  },
  Image: {
    id: 'Image',
    defaultMessage: 'Image',
  },
  AltText: {
    id: 'Alt text',
    defaultMessage: 'Alt text',
  },
  Align: {
    id: 'Alignment',
    defaultMessage: 'Alignment',
  },
  size: {
    id: 'Image size',
    defaultMessage: 'Image size',
  },
  device: {
    id: 'Mostra su',
    defaultMessage: 'Mostra su',
  },
  device_desktop_mobile: {
    id: 'Desktop e mobile',
    defaultMessage: 'Desktop e mobile',
  },
  device_desktop: {
    id: 'Desktop',
    defaultMessage: 'Desktop',
  },
  device_mobile: {
    id: 'Mobile',
    defaultMessage: 'Mobile',
  },
  LinkTo: {
    id: 'Link to',
    defaultMessage: 'Link to',
  },
  openLinkInNewTab: {
    id: 'Open in a new tab',
    defaultMessage: 'Open in a new tab',
  },
  natural_image_size: {
    id: 'natural_image_size',
    defineMessages: "Non alterare le dimensioni naturali dell'immagine",
  },
  AltTextHint: {
    id: 'Alt text hint',
    defaultMessage: 'Leave empty if the image is purely decorative.',
  },
  AltTextHintLinkText: {
    id: 'Alt text hint link text',
    defaultMessage: 'Describe the purpose of the image.',
  },
});

export function ImageSchema({ formData, intl }) {
  return {
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: [
          ...(formData.url
            ? formData.align === 'full'
              ? ['url', 'alt', 'align', 'naturalSize', 'device']
              : ['url', 'alt', 'align', 'size', 'device']
            : []),
        ],
      },
      ...(formData.url
        ? [
            {
              id: 'link_settings',
              title: 'Link settings',
              fields: ['href', 'openLinkInNewTab'],
            },
          ]
        : []),
    ],
    properties: {
      url: {
        title: intl.formatMessage(messages.Source),
        widget: 'url',
      },
      alt: {
        title: intl.formatMessage(messages.AltText),
        description: (
          <>
            <a
              href="https://www.w3.org/WAI/tutorials/images/decision-tree/"
              title={intl.formatMessage(messages.openLinkInNewTab)}
              target="_blank"
              rel="noopener noreferrer"
            >
              {intl.formatMessage(messages.AltTextHintLinkText)}
            </a>{' '}
            {intl.formatMessage(messages.AltTextHint)}
          </>
        ),
        widget: 'textarea',
      },
      align: {
        title: intl.formatMessage(messages.Align),
        widget: 'align',
      },
      naturalSize: {
        title: intl.formatMessage(messages.natural_image_size),
        type: 'boolean',
      },
      size: {
        title: intl.formatMessage(messages.size),
        widget: 'image_size',
      },
      device: {
        title: intl.formatMessage(messages.device),
        widget: 'select',
        choices: [
          [
            'desktop-mobile',
            intl.formatMessage(messages.device_desktop_mobile),
          ],
          ['desktop', intl.formatMessage(messages.device_desktop)],
          ['mobile', intl.formatMessage(messages.device_mobile)],
        ],
        default: 'desktop-mobile',
      },
      href: {
        title: intl.formatMessage(messages.LinkTo),
        widget: 'object_browser',
        mode: 'link',
        selectedItemAttrs: ['Title', 'Description', 'hasPreviewImage'],
        allowExternals: true,
      },
      openLinkInNewTab: {
        title: intl.formatMessage(messages.openLinkInNewTab),
        type: 'boolean',
      },
    },
    required: [],
  };
}

export const gridImageDisableSizeAndPositionHandlersSchema = ({
  schema,
  formData,
  intl,
}) => {
  schema.fieldsets[0].fields = schema.fieldsets[0].fields.filter(
    (item) => !['align', 'size'].includes(item),
  );
  return schema;
};
